import { render } from "./Assistance.vue?vue&type=template&id=406bb9e8"
import script from "./Assistance.vue?vue&type=script&lang=js"
export * from "./Assistance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__